import styled from 'styled-components';

import { DESKTOP_BP } from 'src/_AppContainer';
import * as mx from 'core/styles/mixins';

export const List = styled.ul`
	${mx.listReset}
	display: flex;
	flex-flow: column wrap;

	li {
		width: 100%;
		margin: 0 0 20px;

		&:last-of-type {
			margin-bottom: 0;
		}

		a {
			text-decoration: none;
		}
	}

	${mx.bp(DESKTOP_BP)`
		flex-direction: row;

		li {
			width: 50%;
		}
	`}
`;

export const MessageUsButton = styled.button`
	${mx.buttonReset}
	text-align: left;
`;
